import React, { useState } from 'react';
interface FAQItem {
  question: string;
  answer: string;
}
const faqs: FAQItem[] = [{
  question: '¿Sirve para todos los niveles?',
  answer: 'Sí. Los 6 tomos cubren desde A1 hasta C2, con contenido independiente en cada nivel. Podés adquirir y usar solo lo que necesitás.'
}, {
  question: '¿Cómo recibo el material?',
  answer: '100% digital en PDF. Recibís acceso en menos de 5 minutos con un enlace seguro de descarga a tu correo electrónico.'
}, {
  question: '¿Qué lo diferencia del material gratuito en internet?',
  answer: 'Todo está pre-estructurado, secuenciado y alineado al nivel. Sin buscar, sin adaptar, sin armar. Es un sistema completo — no una colección de recursos sueltos.'
}, {
  question: '¿La garantía es real?',
  answer: 'Absolutamente. Si en 7 días el producto no cumple tus expectativas, devolvemos el 100% de tu pago — sin condiciones ni demoras.'
}, {
  question: '¿En qué moneda voy a pagar?',
  answer: 'Los precios están expresados en USD como referencia. Al momento del pago, se te cobrará automáticamente en la moneda de tu país.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-[#0a0a0a] py-16 px-4" data-id="element-128">
      <div className="max-w-3xl mx-auto" data-id="element-129">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-10" data-id="element-130">
          ❓ LO QUE MÁS NOS PREGUNTAN
        </h2>

        <div className="space-y-3 mb-10" data-id="element-131">
          {faqs.map((faq, i) => <div key={i} className={`rounded-xl border transition-colors ${openIndex === i ? 'border-[#00C853] bg-[#000d08]' : 'border-[#00C853]/20 bg-black'}`} data-id="element-132">
              <button className="w-full text-left px-5 py-4 flex items-center justify-between gap-3" onClick={() => setOpenIndex(openIndex === i ? null : i)} aria-expanded={openIndex === i} data-id="element-133">
                <span className="text-white font-bold text-sm sm:text-base" data-id="element-134">
                  {faq.question}
                </span>
                <span className={`text-[#00C853] text-xl flex-shrink-0 transition-transform ${openIndex === i ? 'rotate-45' : ''}`} data-id="element-135">
                  +
                </span>
              </button>
              {openIndex === i && <div className="px-5 pb-5" data-id="element-136">
                  <div className="h-px bg-[#00C853]/20 mb-4" data-id="element-137" />
                  {faq.answer.split('\n\n').map((para, j) => <p key={j} className="text-gray-200 text-sm leading-relaxed mb-3 last:mb-0" data-id="element-138">
                      {para}
                    </p>)}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}